import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  hintText: {
    id: 'components.GlobalSearch.hintText',
    defaultMessage: 'Find patients by name, birthdate or phone numbers...',
  },
});
